/** @jsxImportSource @emotion/react */

import { cardCSS } from "./Card.css";
import type { CardProps } from "./Card.types";
import { CardBody } from "./CardBody";
import type { CardHeaderProps } from "./CardHeader";
import { CardHeader } from "./CardHeader";
import { CardSection } from "./CardSection";

export const Card = ({
  children,
  size = "default",
  as: Element = "div",
  className,
  sx,
  inline,
  native,
}: CardProps) => {
  return (
    <Element
      className={className}
      data-clay-card-inline={inline}
      data-clay-card-size={size}
      css={[cardCSS({ size, inline }), sx]}
      {...native}
    >
      {children}
    </Element>
  );
};

Card.Header = CardHeader;
Card.SubHeader = (props: Omit<CardHeaderProps, "header">) => <CardHeader size="small" {...props} />;
Card.Section = CardSection;
Card.Body = CardBody;
